class _ {
    constructor(t) {
        (this.status = 422), (this.message = "Cart Error"), (this.description = t);
    }
}
class w {
    constructor() {
        (this.status = 404), (this.message = "Cart Error"), (this.description = "Cannot find variant");
    }
}
class m {
    init() {
        this.emitCartChanges().then(() => {
            this.observeCartChanges();
        });
    }
    checkResponse(t) {
        if (t.status === 404) throw new w();
        if (t.status === 422) throw new _(t.description);
        if (t.token) return t;
        throw new Error("No token provided in the Shopify Cart response");
    }
    async fetchCart() {
        const e = await (await fetch("/cart.js", { headers: { cache: "no-store" } })).json();
        return this.checkResponse(e);
    }
    storeCart(t) {
        localStorage.setItem("juo-cart", JSON.stringify(t));
    }
    storedCart() {
        const t = localStorage.getItem("juo-cart");
        return t != null ? JSON.parse(t) : { items: [] };
    }
    findCartChanges(t, e) {
        const a = (l, c) => l.filter((h) => !c.some((d) => h.key == d.key)),
            i = { added: a(e.items, t.items), removed: a(t.items, e.items) };
        return (
            t.items.forEach((l) => {
                const c = e.items.find((y) => y.key == l.key && y.quantity != l.quantity);
                if (!c) return;
                const h = c.quantity - l.quantity,
                    d = { ...c };
                (d.quantity = Math.abs(h)), h > 0 ? i.added.push(d) : i.removed.push(d);
            }),
            i
        );                
    }
    async emitCartChanges() {
        const t = await this.fetchCart(),
            e = this.storedCart(),
            a = this.findCartChanges(e, t);
        if (a.added.length > 0 || a.removed.length > 0) {
            const i = new CustomEvent("cart_changed", { detail: a });
            this.storeCart(t), window.dispatchEvent(i);
        }
    }
    observeCartChanges() {
        (this.cartObserver = new PerformanceObserver((t) => {
            t.getEntries().forEach((e) => {
                const a = ["xmlhttprequest", "fetch"].includes(e.initiatorType),
                    i = /\/cart\//.test(e.name);
                a && i && this.emitCartChanges();
            });
        })),
            this.cartObserver.observe({ entryTypes: ["resource"] });
    }
    stop() {
        this.cartObserver.disconnect();
    }
}
(function () {
    const g = ".juo-btn-checkout-sell",
        t = "form[action*='/cart']",
        e = new m(),
        a = new Map();
    async function i() {
        var o;
        const s = document.querySelector(g);
        if (!s) return;
        s.setAttribute("disabled", "disabled"), a.clear();
        const u = await fetch("/?section_id=juo-selling-plans");
 
        if (u.status !== 200) {
            console.error("Failed to load selling plans");
            return;
        }
        try {
            const n = document.createElement("div");
            n.innerHTML = await u.text();
            const p = JSON.parse(((o = n.querySelector("template")) == null ? void 0 : o.innerHTML) ?? "{}");
            Object.entries(p).map(([r, f]) => {
                f != null && a.set(r, f);
            });
        } catch {
            console.error("Failed to load selling plans");
        }
        e.storedCart().items.filter((n) => n.selling_plan_allocation).length == a.size && s.removeAttribute("disabled");
    }
    function l() {
        const s = document.querySelector(t);
        if (!s) {
            console.warn("No cart form found");
            return;
        }
        const o = e.storedCart().items.some((n) => n.selling_plan_allocation);
        s.classList[o ? "add" : "remove"]("has-selling-plan"), o && i();
    }
    async function c() {
        e.init(), document.addEventListener("click", h), window.addEventListener("cart_changed", l), i();
    }
    async function h(s) {
        if (s == null) return;
        const u = (s == null ? void 0 : s.target).matches(g) ? s.target : null;
        if (u == null) return;
        s.target.disabled = !0;
        const o = e.storedCart();
        if (!o.items.some((r) => (r.selling_plan_allocation != null ? a.has(String(r.key)) : !1))) {
            window.location.href = "/checkout";
            return;
        }
        const p = o.items.map((r) => {
            const f = r.selling_plan_allocation != null ? a.get(String(r.key)) : null;
            return {
                id: r.variant_id,
                quantity: r.quantity,
                properties: {
                    ...r.properties,
                    ...(r.selling_plan_allocation != null && f != null
                        ? { _selling_plan_id: String(r.selling_plan_allocation.selling_plan.id) }
                        : {}),
                },
                ...(r.selling_plan_allocation != null
                    ? { selling_plan: f ?? String(r.selling_plan_allocation.selling_plan.id) }
                    : {}),
            };
        });
        fetch(window.Shopify.routes.root + "cart/clear").then(async () => {
            try {
                const r = await fetch(window.Shopify.routes.root + "cart/add.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ attributes: o.attributes, items: p }),
                });
                setTimeout(() => {
                    if (r.status !== 200) throw new Error("Failed to add items to cart");
                    u.removeAttribute("disabled"), e.stop(), (window.location.href = "/checkout?skip_shop_pay=true");
                }, 100);
            } catch (r) {
                console.error(r), e.observeCartChanges();
            }
        });
    }
    async function d() {
        const s = await e.fetchCart();
        if (!s.items.some((n) => n.properties._selling_plan_id != null && n.properties._selling_plan_id !== "")) return;
        const o = s.items.map((n) => {
            const p = n.properties._selling_plan_id != null && n.properties._selling_plan_id !== "";
            return {
                id: n.variant_id,
                quantity: n.quantity,
                properties: { ...n.properties, ...(p ? { _selling_plan_id: "" } : {}) },
                ...(p ? { selling_plan: n.properties._selling_plan_id } : {}),
            };
        });
        await fetch(window.Shopify.routes.root + "cart/clear"),
            await fetch(window.Shopify.routes.root + "cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ attributes: s.attributes, items: o }),
            });
    }
    function y() {
        window.Shopify != null && (c(), l(), d());
    }
    document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", y) : y();
})();
